import { Col, Form, Row, Space, Typography } from "antd";
import { t } from "i18next";
import ComboFixedPriceForm from "../components/ComboFixedPriceForm";
import { PlusOutlined } from "@ant-design/icons";
import Card from "features/Cart/components/Card";
import { COMBO_CAMPAIGN, TYPE_LIMIT } from "features/Campaign/constants";
import { useState } from "react";

import ImportExcelModal from "../components/ImportExcelModal";

function FixedPriceForm({
  dataTiersServer: initialDataTiersServer,
  form,
  handleRemoveValueComboSelected,
  isUpdate,
  promotionCampaignTiers,
  initFormFixedPrice,
  indexErrorCombo,
  onGetDataFixedPrice,
}) {
  const [dataTiersServer, setDataTiersServer] = useState(initialDataTiersServer || []);

  const handleImportSuccess = (tierGroups) => {
    if (tierGroups && tierGroups.length > 0) {
      const convertedTierGroups = tierGroups.map((tierGroup) => {
        const maxQuantity = tierGroup?.maxQuantityPerSeller || 0;
        const limitType = maxQuantity > 0 ? TYPE_LIMIT.LIMIT : TYPE_LIMIT.NO_LIMIT;

        const convertedTiers = tierGroup?.promotionCampaignTiers?.map((tier) => {
          const tierMaxQuantity = tier?.maxQuantityPerSeller || 0;
          const tierLimitType = tierMaxQuantity > 0 ? TYPE_LIMIT.LIMIT : TYPE_LIMIT.NO_LIMIT;

          return {
            type: COMBO_CAMPAIGN.FIXED_PRICE,
            minQuantity: tier?.minQuantity || null,
            maxQuantityPerSeller: tierMaxQuantity > 0 ? tierMaxQuantity : null,
            limitType: tierLimitType,
            fixedComboPrice: tier?.fixedComboPrice || null,
            conditionProductGroups:
              tier?.conditionProductGroups?.length > 0
                ? tier.conditionProductGroups.map((group) => ({
                    quantity: group?.quantity || 1,
                    conditionPromotionProducts: group?.conditionPromotionProducts
                      ?.filter((prod) => prod?.productID || prod?.id || prod?.product?.id)
                      .map((prod) => {
                        const productId = prod?.productID || prod?.id || prod?.product?.id;
                        return {
                          productID: productId,
                          product: prod?.product?.id ? prod?.product : { ...prod?.product, id: productId },
                        };
                      }),
                  }))
                : [{ quantity: 1, conditionPromotionProducts: [] }],
          };
        });

        return {
          type: COMBO_CAMPAIGN.FIXED_PRICE,
          maxQuantityPerSeller: maxQuantity > 0 ? maxQuantity : null,
          budgetProductQuantity: tierGroup?.budgetProductQuantity ?? null,
          limitType: limitType,
          promotionCampaignTiers: convertedTiers,
        };
      });

      // Get existing data from form
      const existingData = form.getFieldValue("promotionCampaignTierGroupsFixedPrice") || [];

      // Check if existing combos are empty (no products selected)
      const hasEmptyCombos = existingData.some(
        (combo) => !combo?.promotionCampaignTiers?.[0]?.conditionProductGroups?.[0]?.conditionPromotionProducts?.length
      );

      // If there are empty combos, replace them with imported data
      // Otherwise, append imported data to existing data
      const mergedData = hasEmptyCombos ? convertedTierGroups : [...existingData, ...convertedTierGroups];

      form.setFieldsValue({
        promotionCampaignTierGroupsFixedPrice: mergedData,
      });

      setDataTiersServer(mergedData);
      onGetDataFixedPrice && onGetDataFixedPrice(mergedData);
    }
  };

  return (
    <Card
      title={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Typography.Title level={5} style={{ textTransform: "uppercase", margin: 0 }}>
            {t("campaign.combo.comboFixedPrice")}
          </Typography.Title>
          <div onClick={(e) => e.stopPropagation()}>
            <ImportExcelModal
              campaignType="FIXED_PRICE"
              onImportSuccess={handleImportSuccess}
              title="Upload file thông tin khuyến mãi"
            />
          </div>
        </div>
      }
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Typography.Text italic className="title-main">
          {t("campaign.combo.noteComboFixedPrice")}
        </Typography.Text>
        <Form.List name={"promotionCampaignTierGroupsFixedPrice"}>
          {(fields, { add, remove }) => {
            return (
              <Row gutter={[16, 16]}>
                {fields.map((field, index) => (
                  <Col span={24} key={field.key}>
                    <ComboFixedPriceForm
                      remove={() => remove(field.name)}
                      indexComboFixedPrice={index}
                      onRemoveValueComboSelected={handleRemoveValueComboSelected}
                      form={form}
                      promotionCampaignTiers={promotionCampaignTiers}
                      isUpdate={isUpdate}
                      indexErrorCombo={indexErrorCombo}
                      dataTiersServer={dataTiersServer}
                      onGetDataFixedPrice={onGetDataFixedPrice}
                    />
                  </Col>
                ))}
                <Col span={24}>
                  <Typography.Link underline onClick={() => add(initFormFixedPrice)}>
                    <PlusOutlined /> {t("campaign.combo.addComboFixedPrice")}
                  </Typography.Link>
                </Col>
              </Row>
            );
          }}
        </Form.List>
      </Space>
    </Card>
  );
}

export default FixedPriceForm;
